import payment from "@/plugins/api/factories/PaymentHistory";

export const state = {
  filterValues: null,
  paymentHistory: {},
  ls: null,
};

export const actions = {
  async getPaymentHistory({ commit, state }) {
    const params =
      state.ls && typeof state.ls === "object" ? state.ls : { ls: state.ls };

    if (!params.ls) {
      commit("SET_PAYMENT_HISTORY", []);
      return false;
    }

    await payment.getPaymentHistory(params, (response) => {
      commit("SET_PAYMENT_HISTORY", response.payments);
    });
  },
};

export const mutations = {
  SET_FILTER_VALUES(state, filterValues) {
    state.filterValues = filterValues;
  },
  SET_LS(state, ls) {
    state.ls = ls;
  },
  SET_PAYMENT_HISTORY(state, paymentHistory) {
    state.paymentHistory = paymentHistory;
  },
};
